import { j as e } from "./jsx-runtime.DGlMoOmv.js";
import { FormattedMessage as o } from "react-intl";
import { T as l } from "./Text.BGhoO_e3.js";
import { i as u } from "./format._HymmFPq.js";
import { p as w } from "./parseISO.Fg4DHoUS.js";
import { f as i } from "./index.BibbCfRO.js";
const y = (t) => {
  try {
    return Intl.DateTimeFormat(void 0, {
      timeZone: t
    }), !0;
  } catch {
    return !1;
  }
}, N = ({
  availability: t,
  date: a,
  timeZone: c
}) => {
  const s = y(c) ? c : "UTC", m = (f) => {
    switch (f) {
      case "partially-booked":
        return /* @__PURE__ */ e.jsx(o, { id: "13+NSP", defaultMessage: [{
          type: 0,
          value: "Partially Booked"
        }] });
      case "fully-booked":
        return /* @__PURE__ */ e.jsx(o, { id: "NZ3ZWg", defaultMessage: [{
          type: 0,
          value: "Fully Booked"
        }] });
      case "available":
      default:
        return /* @__PURE__ */ e.jsx(o, { id: "PgJGHT", defaultMessage: [{
          type: 0,
          value: "Available"
        }] });
    }
  }, r = u(a) ? a : w(a), d = i(r, s, "MMM"), n = i(r, s, "d"), p = i(r, s, "EEEE");
  return /* @__PURE__ */ e.jsxs("div", { className: "tw-rounded-2 tw-w-full tw-p-12 sm:tw-px-16 tw-border tw-border-gray-500 tw-flex tw-gap-16 tw-items-center", children: [
    /* @__PURE__ */ e.jsxs("div", { className: "tw-w-full", children: [
      /* @__PURE__ */ e.jsx(l, { typeface: "headline-2-m", className: "tw-block tw-mb-4", children: `${d} ${n}` }),
      /* @__PURE__ */ e.jsx(l, { typeface: "caption-2", className: "tw-text-gray-600 tw-block", children: p })
    ] }),
    /* @__PURE__ */ e.jsx(l, { typeface: "body-2-m", className: "tw-whitespace-nowrap", children: m(t) })
  ] });
};
export {
  N as A
};
//# sourceMappingURL=AvailabilityBlock.wTbqFj9F.js.map
